const defaultState = {
  propertyTypes: [],
  adTypes: [],
  zones: []
};

export default defaultState;
